import { Inject } from 'inversify-props';
import type { AssistenteIAServiceAdapter } from './adapter/AssistenteIAServiceAdapter';
import { AxiosRequestConfig } from 'axios';
import { MensagemAssistenteIA } from '@/models/assistente-ia';


export class AssistenteIAUseCase {
	@Inject("AssistenteIAServiceAdapter")
	private assistenteIAServiceAdapter!: AssistenteIAServiceAdapter

	async perguntar(params?: any, config?: AxiosRequestConfig): Promise<string> {
		return await this.assistenteIAServiceAdapter.perguntar(params, config)
	}

	async buscarMensagens(config?: AxiosRequestConfig): Promise<MensagemAssistenteIA[]> {
		return await this.assistenteIAServiceAdapter.buscarMensagens(config)
	}

	async criarNovaThread(): Promise<void> {
		return await this.assistenteIAServiceAdapter.criarNovaThread()
	}
}